export const FREESTAR_PUBLISHER = 'benzinga-com';
export const FREESTAR_STICKY_FOOTER_MOBILE_ENABLED = true;
export const FREESTAR_STICKY_FOOTER_PLACEMENT = 'benzinga-com_sticky_footer';
export const FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT = 'benzinga-com_sticky_footer_mobile';
export const FREESTAR_STICKY_FOOTER_MOBILE_MAX_WIDTH = 767;

export const resolveFreestarStickyFooterPlacement = (viewportWidth: number): string =>
  viewportWidth <= FREESTAR_STICKY_FOOTER_MOBILE_MAX_WIDTH
    ? FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT
    : FREESTAR_STICKY_FOOTER_PLACEMENT;

export const shouldDisableFreestarStickyFooterForPage = ({
  adsFullyDisabled,
  disableFooterDisplayAd,
  dismissed = false,
  suppressNonSidebarAds,
}: {
  adsFullyDisabled: boolean;
  disableFooterDisplayAd: boolean;
  dismissed?: boolean;
  suppressNonSidebarAds: boolean;
}): boolean => adsFullyDisabled || suppressNonSidebarAds || dismissed || disableFooterDisplayAd;

export type FreestarPlacement =
  | 'top_header'
  | 'incontent'
  | 'sidebar_1'
  | 'sidebar_2'
  | 'belowcontent'
  | 'infeed'
  | 'native';

export const FREESTAR_PLACEMENTS: readonly FreestarPlacement[] = [
  'top_header',
  'incontent',
  'sidebar_1',
  'sidebar_2',
  'belowcontent',
  'infeed',
  'native',
] as const;

export const isFreestarPlacement = (type: string | null | undefined): type is FreestarPlacement =>
  typeof type === 'string' && (FREESTAR_PLACEMENTS as readonly string[]).includes(type);

export const FREESTAR_INCONTENT_MAX = 5;
export const FREESTAR_INFEED_MAX = 4;
export const FREESTAR_NATIVE_MAX = 2;

export const freestarPlacementHeightMap: Record<FreestarPlacement, string> = {
  belowcontent: 'min-h-[250px] max-h-[250px]',
  incontent: 'min-h-[250px] max-h-[250px]',
  infeed: 'min-h-[250px] max-h-[250px]',
  native: 'min-h-[250px] max-h-[250px]',
  sidebar_1: 'min-h-[250px] max-h-[250px]',
  sidebar_2: 'min-h-[250px] max-h-[250px]',
  top_header: 'min-h-[90px] max-h-[90px]',
};

const SIDEBAR_WIDTH_CLASS = 'min-w-[300px] w-[300px]';
const SPAN_WIDTH_CLASS = 'w-full';

export const hasExplicitWidthClass = (className?: string): boolean =>
  typeof className === 'string' &&
  /(?:^|\s)(?:min-|max-)?w-(?:full|screen|svw|lvw|dvw|min|max|fit|px|auto|\[|\d)/.test(className);

export const freestarPlacementWidthClass = (placement: FreestarPlacement, className?: string): string => {
  if (hasExplicitWidthClass(className)) return '';
  return placement === 'sidebar_1' || placement === 'sidebar_2' ? SIDEBAR_WIDTH_CLASS : SPAN_WIDTH_CLASS;
};

export const freestarPlacementName = (placement: FreestarPlacement, index?: number): string => {
  switch (placement) {
    case 'top_header':
      return 'benzinga-com_top_header';
    case 'belowcontent':
      return 'benzinga-com_belowcontent';
    case 'sidebar_1':
      return 'benzinga-com_sidebar_1';
    case 'sidebar_2':
      return 'benzinga-com_sidebar_2';
    case 'incontent':
      return `benzinga-com_incontent_${index ?? 1}`;
    case 'infeed':
      return `benzinga-com_infeed_${index ?? 1}`;
    case 'native':
      return `benzinga-com_native_${index ?? 1}`;
  }
};
